import { faAddressCard, faFileSignature } from "@fortawesome/free-solid-svg-icons";

export const links = [
    {
        label: "Client Settings",
        path: "/admin/clients/settings",
        activePaths: ["/admins/clients/settings"],
        icon: faAddressCard,
    },
    {
        label: "SLA Groups",
        path: "/admin/clients/groups",
        activePaths: ["/admin/clients/groups"],
        icon: faFileSignature,
    },
];
